<template>
  <router-view />

  <div v-if="lightMood"></div>
  <AlartModal
    v-if="errorModal"
    :message="errorMessage"
    imagePath="close.png"
    @close-modal="closeErrorModalHandler"
  />

  <div class="rotate">
    <div class="phone"></div>
    <div class="message">
      Please use Ipad, Labtop, or Desktop <br />
      In LANDSCAPE mode!
    </div>
  </div>

  <div class="loading-overlay" id="loading" v-if="isLoading && !answersFlag">
    <div class="reverse-spinner"></div>
  </div>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AlartModal = defineAsyncComponent(() =>
  import("./views/components/AlartModal")
);
import getBrowserType from "./helpers/getBrowserType";
import getAppColors from "./helpers/getAppColors";
import { logger } from "./helpers/logger";

export default {
  name: "app-page",
  components: { AlartModal },
  date() {
    return {
      moodColors: {
        mainBg1Color: "#044D6B",
        mainBg2Color: "#021A24",
        mainColor: "#FFF",
      },
    };
  },
  mounted() {
    logger([1], ["2 => ", 2], ["browserDetect => ", getBrowserType()]);

    if (process.env.VUE_ENV === "development")
      console.log("browserDetect => ", getBrowserType());

    this.checkLightMood();

    this.moodColors = getAppColors(this.lightMood);
  },
  computed: {
    lightMood() {
      console.log("EG = ", this.$store.state.settings.isLightMood);
      return this.$store.state.settings.isLightMood;
    },

    errorModal() {
      return this.$store.state.settings.errorModal;
    },
    errorMessage() {
      return this.$store.state.settings.errorMessage;
    },

    answersFlag() {
      return this.$store.state.settings.setAnswersFlag;
    },

    isLoading() {
      return this.$store.state.auth.isLoading;
    },
  },

  updated() {
    console.log("EG.");
    this.moodColors = getAppColors(this.lightMood);
  },
  methods: {
    async closeErrorModalHandler() {
      await this.$store.dispatch("setErrorModal", false);
    },
    async checkLightMood() {
      let isLightmood = localStorage.getItem("lightmood");

      if (isLightmood !== null) {
        isLightmood = isLightmood === "true";
        await this.$store.dispatch("setIsLightMood", isLightmood);
      }
    },
  },
};
</script>
<!--<script>-->
<!--    import {onMounted,onUpdated, computed, defineAsyncComponent, ref} from "vue";-->
<!--    import {useStore} from "vuex";-->
<!--    import getBrowserType from "./helpers/getBrowserType";-->

<!--    const AlartModal = defineAsyncComponent(() =>-->
<!--        import ('./views/components/AlartModal')-->
<!--    );-->

<!--    export default {-->

<!--        name: 'app-page',-->
<!--        components: {AlartModal},-->
<!--        setup() {-->

<!--            const store = useStore();-->
<!--            const moodColors = ref({-->
<!--                mainBg1Color: '#044D6B',-->
<!--                mainBg2Color: '#021A24',-->
<!--                mainColor: '#FFF',-->
<!--            });-->

<!--            onUpdated(() => {-->
<!--                document.documentElement.style.setProperty('&#45;&#45;main-bg1-color', moodColors.value['mainBg1Color']);-->
<!--                document.documentElement.style.setProperty('&#45;&#45;main-bg2-color', moodColors.value['mainBg2Color']);-->
<!--                document.documentElement.style.setProperty('&#45;&#45;main-color', moodColors.value['mainColor']);-->
<!--            });-->
<!--            onMounted(() => {-->
<!--                if (process.env.VUE_ENV === 'development')-->
<!--                    console.log('browserDetect => ', getBrowserType())-->
<!--            });-->
<!--            const closeErrorModalHandler = async () => {-->
<!--                await store.dispatch('setErrorModal', false);-->
<!--            };-->

<!--            return {-->
<!--                moodColors,-->

<!--                lightMood:computed(() =>{-->
<!--                    console.log('ssss')-->
<!--                    if(store.state.settings.isLightMood){-->
<!--                        moodColors.value = {-->
<!--                            mainBg1Color: '#044D6B',-->
<!--                            mainBg2Color: '#021A24',-->
<!--                            mainColor: '#FFF',-->
<!--                        }-->
<!--                    }else{-->
<!--                        moodColors.value = {-->
<!--                            mainBg1Color: '#FFF',-->
<!--                            mainBg2Color: '#FFF',-->
<!--                            mainColor: '#000',-->
<!--                        }-->
<!--                    }-->
<!--                    return store.state.settings.isLightMood-->
<!--                } ),-->
<!--                closeErrorModalHandler,-->
<!--                errorMessage: computed(() => store.state.settings.errorMessage),-->
<!--                errorModal: computed(() => store.state.settings.errorModal),-->
<!--                isLoading: computed(() => store.state.auth.isLoading),-->
<!--                answersFlag: computed(() => store.state.settings.setAnswersFlag),-->
<!--            }-->
<!--        }-->
<!--    }-->
<!--</script>-->
<style>
* {
  font-family: "Poppins", sans-serif;
}

.err {
  text-transform: none !important;
}
.rotate {
  display: none;
  position: fixed;
  left: 0;
  top: 0;
  min-height: 100vh;
  z-index: 99999;
}
.btn-container button{
        background-color: unset;
        border:none;
        color:white;
    }
@media only screen and (max-width: 1000px) and (orientation: landscape) {
  .rotate {
    background: black;
    height: 100%;
    width: 100%;
    display: flex !important;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }

  .rotate .phone {
    height: 50px;
    width: 100px;
    border: 3px solid white;
    border-radius: 10px;
    -webkit-animation: rotate 1.5s ease-in-out infinite alternate;
    animation: rotate 1.5s ease-in-out infinite alternate;
    display: block !important;
  }

  .rotate .message {
    color: white;
    font-size: 1em;
    margin-top: 40px;
    display: block !important;
    text-align: center;
  }
}

@media (max-width: 992px) {
  .rotate {
    background: black;
    height: 100%;
    width: 100%;
    display: flex !important;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }

  .rotate .phone {
    height: 50px;
    width: 100px;
    border: 3px solid white;
    border-radius: 10px;
    -webkit-animation: rotate 1.5s ease-in-out infinite alternate;
    animation: rotate 1.5s ease-in-out infinite alternate;
    display: block !important;
  }

  .rotate .message {
    color: white;
    font-size: 1em;
    margin-top: 40px;
    display: block !important;
    text-align: center;
  }
}

@-webkit-keyframes rotate {
  0% {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(-90deg);
  }
  100% {
    transform: rotate(-90deg);
  }
}

@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(-90deg);
  }
  100% {
    transform: rotate(-90deg);
  }
}

@media only screen and (max-width: 1170px) and (min-width: 1024px) {
  .twoInputs {
    margin-bottom: 10px;
  }
  thead th {
    /*max-width: 50px;*/
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  td {
    max-width: 50px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

@media only screen and (max-width: 1300px) and (min-width: 1250px) {
  thead th {
    max-width: 100px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  td {
    max-width: 100px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

body {
  background-color: var(--main-bg2-color) !important;

  color: var(--main-color) !important;
}

input:checked + .slider {
  background-color: #e95626 !important;
}

textarea {
  resize: none !important;
}

.back-route {
  color: var(--main-color) !important;
}
/*.tabcontent-bark-mode {*/
/*    background-image: linear-gradient(#16303a, #021A24);*/
/*}*/

/*.tabcontent-light-mode {*/
/*    background-image: linear-gradient(#16303a, #021A24);*/
/*}*/

.dp__input {
  height: 40px !important;
  background-color: transparent !important;
  color: var(--input-search-color) !important;
  border: 1px solid var(--tab-border-start-time-end-time) !important;
  border-radius: 6px !important;
}

.reset-data-btn {
  border: 1px solid #e95626;
  border-radius: 4px;
  padding: 6px 30px;
  font-size: 16px;
  font-weight: 300;
  cursor: pointer;
}

.multiselect-dropdown {
  background-color: #0c252f !important;
  color: #fff !important;
}

.multiselect-option.is-selected,
.multiselect-option.is-selected.is-pointed,
.multiselect-option.is-selected.is-pointed:hover,
.multiselect-option.is-selected:hover {
  background-color: #e95626 !important;
}

.filepond--drop-label.filepond--drop-label label {
  cursor: pointer;
}

.multiselect-tags-search {
  background-color: transparent;
}
.multiselect-tag {
  background-color: #e95626 !important;
}

div.multiselect {
  width: 400px;
  margin: 0;
  background-color: transparent;
  color: var(--input-search-color);
}

.designRowOrga {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 0;
  margin-bottom: 20px;
}

.btnOrganization button {
  background-color: #e95626;
  color: #fff;
  border: none;
  border-radius: 5px;
  justify-content: end;
  align-content: center;
  width: 180px;
  padding: 10px;
}

.paginationLink .pagination {
  gap: 5px;
  float: right;
}

.paginationLink .pagination .page-link {
  gap: 5px;
  background-color: var(--btn-pagination-background-color);
  color: var(--btn-pagination-color);
  border:1px solid #F5F5F5;
  padding: 5px 15px;
 
}

.paginationLink .pagination .page-link:hover {
  color: var(--main-color);
}

.paginationLink .pagination .page-item.active .page-link {
  background-color: var(--btn-color-active-color);
  color: #fff;
}

.loading-overlay {
background-color: rgba(0, 0, 0, 0.5);
  color: #fff;
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 100000;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
}

.reverse-spinner {
  position: relative;
  height: 150px;
  width: 150px;
  border: 6px solid transparent;
  border-top-color: #e95626;
  border-left-color: #e95626;
  border-radius: 50%;
  -webkit-animation: spin 1.5s linear infinite;
  animation: spin 1.5s linear infinite;
}

.overlay-hidden {
  display: none !important;
}

.reverse-spinner::before {
  position: absolute;
  top: 15px;
  left: 15px;
  right: 15px;
  bottom: 15px;
  content: "";
  border: 6px solid transparent;
  border-top-color: #032230;
  border-left-color: #032230;
  border-radius: 50%;
  -webkit-animation: spinBack 1s linear infinite;
  animation: spinBack 1s linear infinite;
}

@keyframes spinBack {
  from {
    -webkit-transform: rotate(0);
    transform: rotate(0);
  }

  to {
    -webkit-transform: rotate(-720deg);
    transform: rotate(-720deg);
  }
}
.btnInsideInput {
  display: flex;
  flex-direction: row;
  border: 1px solid var(--border-input-color-search);
  border-radius: 3px;
}

.btnInsideInput input,
.btnInsideInput input:focus {
  border: none;
  outline: 0;
  box-shadow: 0 0 0 0;
}

.btnInsideInput button {
  background-color: var(--btn-search-color);
  border: none;
}

.twoInputs #free_search {
  background-color: transparent;
  color: var(--input-search-color);
  width: 250px;
}

.twoInputs #filter {
  background-color: transparent;
  color: #fff;
  width: 250px;
}

.getStatus #statusSeacrh {
  background-color: #152f39;
  border-color: #39525c;
  color: #fff;
  width: 350px;
}

.oneInput #filter_dates {
  /*background-color: #032431;*/
  background-color: var(--secondary-bg1-color);
  color: var(--main-color);
  width: 250px;
  cursor: pointer;
  border: 1px solid var(--border-input-color-search);
}

.getStatus #statusSeacrh {
  background-color: var(--secondary-bg1-color);
  color: var(--main-color);
  border: 1px solid var(--border-input-color-search);
}

#filter_dates:focus {
  outline: 0;
  box-shadow: 0 0 0 0 !important;
}

::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: var(--main-color) !important;
  opacity: 1; /* Firefox */
}

:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: var(--main-color);
}

::-ms-input-placeholder {
  /* Microsoft Edge */
  color: var(--main-color);
}

.twoInputs {
  display: flex;
  flex-direction: row;
  gap: 20px;
}

.fullInputs {
  display: flex;
  flex-wrap: wrap;
}

.fullInputs {
  justify-content: space-between;
}

.tabcontent {
  display: block;
  padding: 30px !important;
  height:67vh;
  overflow-y: hidden;
  border-radius: 3px;
}

.tabcontent-border-style {
  border-radius: 0 20px 20px 20px;
}

.tab {
  overflow: hidden;
}

.tab button {
  background-color: inherit;
  color: #fff;
  float: left;
  border: none;
  outline: none;
  cursor: pointer;
  padding: 7px 32px;
  transition: 0.3s;
  font-size: 17px;
}

.tab button:hover {
  /* background-image: linear-gradient(#044d6b, #021a24); */
}

.tab button.active {
  /* background-image: linear-gradient(#044d6b, #021a24); */
  color: #e37450;
  border-radius: 12px 12px 0 0;
}

.btn-container {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: var(--btn-bg-color);
  border-radius: 4px;
  font-size: 19px;
  border: none;
   padding: 5px 15px;
  color: var(--btn-text-color);
}

.btn-container span {
  color: #fff;
}

.btn-container span:hover,
.btn-container:hover,
.btn-container span:active {
  color: #ffffff;
  outline: 0;
  box-shadow: 0 0 0 0;
}

.scrollbar {
  scrollbar-width: thin !important;
  scrollbar-height: thin !important;
  scrollbar-color: var(--scroll-bar-color) !important;
}

::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}

/* Track */
::-webkit-scrollbar-track {
  background: transparent;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: var(--scroll-bar-color);
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: var(--scroll-bar-color);
}

.filepond--list {
  overflow-y: auto !important;
  height: 105px !important;
}

.table-container {
  position: relative;
}

.paginationLink {
  position: absolute;
  justify-content: end;
  display: flex;
  width: 100%;
  margin-top: 10px;
}

.tab {
  overflow: hidden;
  display: flex;
  gap: 10px;
}

.tab .tablinks {
  width: 180px;
  height: 41px;
  background-color: var(--btn-pagination-background-color);
  color: var(--btn-pagination-color);
  float: left;
  border: 1px solid var(--border-color-data-table);
  outline: none;
  cursor: pointer;
  padding: 8px 16px;
  transition: 0.3s;
  font-size: 16px;
  /*font-family: Poppins,sans-serif;*/
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  border-radius: 10px 10px 0 0;
}

.tab .tablinks:hover,
.tab .tablinks.active {
  background-color: var(--tab-color-competition-training);
  color: white;
}

.q-body {
  /* border: 1px solid var(--border-color-data-table); */
  /* padding: 10px; */
  border-radius: 4px;
  margin-bottom: 20px;
  overflow: auto;
}

.err {
  text-transform: capitalize;
}

::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: var(--main-color) !important;
  opacity: 0.5 !important; /* Firefox */
}

:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: var(--main-color) !important;
}

::-ms-input-placeholder {
  /* Microsoft Edge */
  color: var(--main-color) !important;
}
</style>
